import J, { STORAGE_KEYS as i } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new J.ee(null, !0).jr(i.re);
}
